import * as Yup from 'yup';

import { PersonalDetailsResponse } from 'utils/api/modules/user/user.types';

type SchemaObject = {
  [key in keyof PersonalDetailsResponse]: Yup.Schema;
};

export const EditMedicalInformationSchema = Yup.object().shape<Partial<SchemaObject>>({});
